import ArtistCard from "@/components/ArtistCard";
import { Box, Center, Container, SimpleGrid } from "@chakra-ui/react";

interface ACPropsCollector {
  name: string;
  id: number;
}

interface CardFile {
  file_name: string;
}

interface ACSProps {
  id: number;
  issued: string;
  inc_list?: string[];
  quantity?: number;
  slug: string;
  sold_out?: boolean;
  includes?: string;
  desc?: string;
  uuid: string;
  price?: number;
  comp_file?: string;
  thumbnail?: string;
  title: string;
  image?: string;
  ext_file: string;
  song: {
    id: number;
    title: string;
    file?: string;
    ext_file?: string;
  };
  collector: ACPropsCollector[];
  files: CardFile[];
  primary_artist: {
    name: string;
    slug: string;
  };
}

interface ACSCardsProps {
  cards: ACSProps[];
}

function ArtistCards(props: ACSCardsProps) {
  return (
    <div>
      <Container mt={5}>
        <Box position="relative" mt={5}>
          <Center></Center>
        </Box>
      </Container>
      <SimpleGrid minChildWidth="300px" spacing={5} mb={20}>
        {props.cards.map((card, index) => (
          <ArtistCard card={card} key={index} />
        ))}
      </SimpleGrid>
    </div>
  );
}

export default ArtistCards;
